import Carousel from 'react-multi-carousel'
import './carouselStyle.css'
import HotbuyTile from '../Components/HotbuyTile'
import CategortTile from '../Components/CategoryTile'
import CutpriceTile from '../Components/CutpriceTile'

const WhiteTilesSlier = props => {
const productsInfo =  props.productsInfo
const bgImage = props.bgImage
const pageUrl = props.pageUrl
const headerColor = props.headerColor
//console.log('props.productsInfo:',productsInfo,bgImage,pageUrl)
const responsiveWhiteTile = {
    desktop: {
      breakpoint: { max: 3000, min: 992 },
      items: 4,
      slidesToSlide: 4,
    },
    tabletLandscape: {
      breakpoint: { max: 991, min: 768 },
      items: 3,
      slidesToSlide: 1
    },
    tabletPortrait: {
      breakpoint: { max: 767, min: 250},
      items: 1,
      slidesToSlide: 1
    }

  }

const tileTaggingHandler = () => {
    window.dataLayer.push({'event': 'white_tiles_slider','TGGEventCategory':'White Tiles Panel','TGGEventAction':'Tiles Click' ,'TGGEventLabel':`${pageUrl}`})
    //console.log('tile is clicked')
}
const arrowTaggingHandler_rigth = () => {
    window.dataLayer.push({'event': 'white_tiles_slider','TGGEventCategory':'White Tiles Panel','TGGEventAction':'Arrow slider right click' ,'TGGEventLabel':`${pageUrl}`})
    //console.log('right arrow is clicked')
}
const arrowTaggingHandler_left = () => {
    window.dataLayer.push({'event': 'white_tiles_slider','TGGEventCategory':'White Tiles Panel','TGGEventAction':'Arrow slider left click' ,'TGGEventLabel':`${pageUrl}`})
    //console.log('left arrow is clicked')
}

let whiteTiles
let dragging = false

{productsInfo && productsInfo !== undefined ? whiteTiles = productsInfo.map(pInfo => {
  //console.log('pInfo:',pInfo)
      if(pInfo.type === 'HotBuy'){
        //console.log('IS HOT BUY')
         return <HotbuyTile info={pInfo} key={pInfo.sku} sku={pInfo.sku} onClick={tileTaggingHandler} bgImage={bgImage} headerColor={headerColor}/>
      }else if( pInfo.type === 'CutPrice'){
        //console.log('IS CUT PRICE')
          return <CutpriceTile info={pInfo} key={pInfo.sku} sku={pInfo.sku} onClick={tileTaggingHandler} bgImage={bgImage} headerColor={headerColor}/>
      }else if( pInfo.type === 'Category'){
        //console.log('IS CATEGORY')
          return <CategortTile info={pInfo} key={pInfo.sku} sku={pInfo.sku} onClick={tileTaggingHandler} bgImage={bgImage} headerColor={headerColor}/>
      }
  }) : whiteTiles = null}

  const CustomRightArrow = ({ onClick, ...rest }) => {
    const {
      onMove,
      carouselState: { currentSlide, deviceType }
    } = rest;
    // onMove means if dragging or swiping in progress.
    return <button className="react-multiple-carousel__arrow react-multiple-carousel__arrow--right " onClick={() => {
        arrowTaggingHandler_rigth()
        onClick()
        }
    } />;
  };
  const CustomLeftArrow = ({ onClick, ...rest }) => {
    const {
      onMove,
      carouselState: { currentSlide, deviceType }
    } = rest;
    // onMove means if dragging or swiping in progress.
    return <button className="react-multiple-carousel__arrow react-multiple-carousel__arrow--left " onClick={() => {
        arrowTaggingHandler_left()
        onClick()
        }
    } />;
  };

  var settings = {
  beforeChange: () => dragging = true,
  afterChange: () => dragging = false,
}

    return(
        <div className="whiteTiles_slider marg-bottom-20">
            {productsInfo && productsInfo !== undefined ?
            <Carousel {...settings}
               arrows={props.showArrows}
               customRightArrow={<CustomRightArrow />}
                customLeftArrow={<CustomLeftArrow />}
               swipeable={true}
               draggable={true}
               showDots={false}
               responsive={responsiveWhiteTile}
               ssr={true} // means to render carousel on server-side.
               infinite={true}
               partialVisible={true}
               autoPlay={props.showArrows}
               autoPlaySpeed={props.autoPlaySpeed}
               keyBoardControl={true}
               customTransition="transform 800ms ease-in-out"
               transitionDuration={800}
               containerClass="carousel-container"
               itemClass="carousel-item-padding-40-px">
                    {whiteTiles }
            </Carousel> : null }
        </div>
        )
}

export default WhiteTilesSlier